import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { personalizationSelector } from 'viewModel/selectors/personalization/personalizationSelector';
import { coreUserDataSelector } from 'viewModel/selectors/user/coreUserDataSelector';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import PromotionListTrendingOffersHandlerEN from 'components/Content/PromotionListHandler/PromotionListTrendingOffersHandler/locales/PromotionListTrendingOffersHandler_en_US';
import PromotionListTrendingOffersHandlerFR from 'components/Content/PromotionListHandler/PromotionListTrendingOffersHandler/locales/PromotionListTrendingOffersHandler_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(PromotionListTrendingOffersHandlerEN, PromotionListTrendingOffersHandlerFR);

// This handler is mounted only when the trending constraints hold (anonymous + trending flags on) —
// eligibility and fall-through to the next available handler are resolved by getCmsComponent. So the
// viewModel only produces the anon-trending presentation: new title + per-page sign-in CTA. The
// subtitle is built from locale strings (not CMS) — signInCtaLabel is the clickable/leading phrase,
// signInSubtitle is the non-clickable remainder; PromotionList composes them per page.
const fields = createSelector(
    coreUserDataSelector,
    personalizationSelector,
    createStructuredSelector({
        popularOffers: getTextFromResource(getText, 'popularOffers'),
        signIn: getTextFromResource(getText, 'signIn'),
        signInSubtitle: getTextFromResource(getText, 'signInSubtitle')
    }),
    (user, personalization, textResources) => {
        // For SEO: never show skeleton - render content immediately
        const showSkeleton = !Sephora.isSEO && personalization.isPersonalizationInitializing;

        return {
            user,
            showSkeleton,
            title: textResources.popularOffers,
            showSignInCta: true,
            signInCtaLabel: textResources.signIn,
            signInSubtitle: textResources.signInSubtitle
        };
    }
);

const withPromotionListTrendingOffersHandlerProps = wrapHOC(connect(fields));

export {
    fields, withPromotionListTrendingOffersHandlerProps
};
